export default {
  productsCode: [],
  productsCount: 0,
  materialGroup: '',
  compareData: {},
  compareVisible: false,
  compareOpen: false,
  compareDataReady: false,
  showDifferences: false,
};
